export default {
    "FETCH_CODE_LIST": "FETCH_CODE_LIST",
    "FETCHING_CODELIST_DATA": "FETCHING_CODELIST_DATA"
}